export * from './GradientText';
export { default as GradientText } from './GradientText';
